import React from 'react';
import VotingDemo from '../components/VotingDemo';

const VotingDemoPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <VotingDemo />
    </div>
  );
};

export default VotingDemoPage; 